import useSWR from 'swr';
import { consignmentService } from 'services';
import { Loading, Product } from 'components';
import { swrKeys } from 'helpers';
import * as S from './styles';

interface Props {
  consignmentCode: string;
}

export function CollectProductList({ consignmentCode }: Props) {
  const { data, isValidating } = useSWR(
    swrKeys.consignmentDetails({ consignmentCode }),
    () => consignmentService.getDetails(consignmentCode),
    {
      revalidateOnFocus: false,
      revalidateIfStale: false,
      revalidateOnReconnect: false,
    }
  );

  const isLoading = !data || isValidating;

  return (
    <S.Main $isLoading={isLoading}>
      <S.Heading>Itens do Pedido: {consignmentCode}</S.Heading>

      {isLoading ? (
        <Loading />
      ) : (
        data.entries.map((entry) => {
          return <Product key={entry.product.code} entry={entry} />;
        })
      )}
    </S.Main>
  );
}
